import { Platform } from 'react-native';

/**
 * Captures a visual snapshot of the screen/activity in Web/PWA mode.
 * Returns a JPEG data URL string (`data:image/jpeg;base64,...`) or null if unavailable.
 */
export async function captureScreenSnapshot(targetElementId?: string): Promise<string | null> {
    if (Platform.OS !== 'web' || typeof window === 'undefined' || typeof document === 'undefined') {
        return null;
    }

    try {
        // Dynamically import html2canvas for web bundles
        const html2canvasModule = await import('html2canvas');
        const html2canvas = html2canvasModule.default || html2canvasModule;

        const target = targetElementId
            ? document.getElementById(targetElementId) || document.body
            : document.body;

        const canvas = await html2canvas(target, {
            logging: false,
            useCORS: true,
            allowTaint: true,
            scale: 1, // Keep snapshot compact for fast upload
        });

        return canvas.toDataURL('image/jpeg', 0.8);
    } catch (err) {
        console.warn('[Screenshot] Failed to capture DOM snapshot:', err);
        return null;
    }
}
